<template>
<div>
    <linkbutton v-if="!showButton" :toplabel="titleText" @click="Start()"/>
    <smallbutton v-if="showButton" @click="Start()" :toplabel="updateText" :class="buttonclass"/>
    <!-- ACCT NOTE MODAL -->
      <actionmodal ref="mymodal"> 
        <template v-slot:body>
            <form ref="myform">
                <label class="titlelabel">{{titleText}}</label>

                <formentry inputid="locationname" :capitalize="paramTrue"  inputtype="text"  label="Location Name" isrequired='True' v-model="location.Name" v-if="isVisible('LocationName')"/>

                <formentry inputid="firstname" :capitalize="paramTrue"  inputtype="text"  label="First Name" isrequired='True' v-model="person.FirstName" v-if="isVisible('FirstName')"/>
                <formentry inputid="lastname" :capitalize="paramTrue"   inputtype="text"  label="Last Name" isrequired='True' v-model="person.LastName"  v-if="isVisible('LastName')"/>

                <formentry inputid="emailaddress" inputtype="email"  label="Email Address"  v-model="person.EmailAddress"  v-if="isVisible('Email')" :isrequired="isRequired('Email')"/>
                <formentry inputid="phonenumber" inputtype="tel"  label="Phone Number" @blur="leavePhone"  v-model="person.PhoneNumber1"  v-if="isVisible('Phone')" :isrequired="isRequired('Phone')"/>
                

                <formentry inputid="address1" label="Address 1"  v-model="person.AddressLine1"  v-if="isVisible('Address')" :isrequired="isRequired('Address')"/>
                <formentry inputid="address2" label="Address 2"  v-model="person.AddressLine2" v-if="isVisible('Address')"/>
                <formentry inputid="city" label="City" :capitalize="paramTrue"   inputtype="text"  v-model="person.City" v-if="isVisible('Address')" :isrequired="isRequired('Address')"/>
                <div class="entry" v-if="isVisible('Address')">
                    <div class="entryTextDiv">
                        <label class="entryLabel" for="stateselect">State</label>
                    </div>
                    <div class="entryTextDiv">
                    <select name="" id="stateselect" class='entrySelect' v-model="person.StateID" :required="isRequired('Address')">
                        <option v-for="state in states" :key="state.id" :value="state.id" >
                            {{state.name}}
                        </option>
                    </select>
                    </div>
                </div>
                <formentry inputid="zip" label="Zip"  v-model="person.ZipCode" v-if="isVisible('Address')" :isrequired="isRequired('Address')"/>
                

                <br>
                <div class="vertFlex ">
                    <label  class="" v-if="showOptInEmail || showOptInSMS">{{personTypeText}} agrees to receive communications through</label>
                    <label  class="" v-if="showOptInEmail && showOptInSMS">(Check at least one)</label>
                
                    <div class="horizFlex centered" v-if="showOptInEmail">
                        <input id="optinemailcheck" class="entryCheckbox" type="checkbox" v-model="person.optInForEmail" >
                        <label for="optinemailcheck" :class="checkClass(person.optInForEmail)">Email</label>
                    </div>

                    <div class="horizFlex topMargin centered" v-if="showOptInSMS">
                        <input id="optinsmscheck" class="entryCheckbox" type="checkbox" v-model="person.optInForText" @change="setoptsms">
                        <label for="optinsmscheck" :class="checkClass(person.optInForText)">Text Messaging</label>
                    </div>
                    <label v-if="showOptInSMS"  class="">({{personTypeText}} has given you consent to send text messages and understands that standard messaging and data rates may apply)</label>
                    

                    <div class="horizFlex topMargin centered" v-if="showOptInSMS && isAdd && isStudent" @change="setwelcome">
                        <input id="sendnewsms" class="entryCheckbox" type="checkbox" v-model="sendNewSMS" >
                        <label for="sendnewsms" :class="checkClass(sendNewSMS)">Check to send Welcome Text</label>
                    </div>
                </div> 
    
                
                <smallbutton  @click="checkNew()" toplabel="Save" v-if="!isRegistered"/>
                <smallbutton  @click="cancelupdate()" toplabel="Cancel" v-if="!isRegistered"/>
                <smallbutton  @click="cancelupdate()" toplabel="Close" v-if="isRegistered"/>

                <div v-if="pleaseWait">
                    <label class="pleasewait">Please Wait...</label>
                </div>
                <div>
                    <label class="responsemessage">{{message}}</label>
               </div>
           
                <confirm ref="confirmsavesamename" :showButton="paramFalse" :body="savewarning" title="Confirm Save With Same Name"
                    @yes="saveNewperson()" :redText="paramTrue"   />

          </form>
        </template>
      </actionmodal>
    </div>
</template>

<script>
import {mapFields} from 'vuex-map-fields'
import datamethods from '../../services/datamethods.js'
import format from '../../format.js'
import smallbutton from '../controls/button.vue'
import actionmodal from '../controls/actionmodal.vue'
import formentry from '../controls/entry.vue'
import linkbutton from '../controls/linkbutton.vue'
import securityhelper from '../../services/securityhelper.js'
import confirm from '../actions/confirm.vue'
export default {
    name:'register',
    components:{
        smallbutton,
        actionmodal,
        formentry,
        linkbutton,
        confirm
    },
    props:{

        titleText:{
            type:String,
            default:'Register'
        },
        
        buttonclass:{
            type:String,
            default:'updatebutton'
        },
        showButton:{
            type:Boolean,
            default:false
        }

    },
    mixins:[datamethods,format,securityhelper],
    data(){
        return{
            message:'',
            person:{},
            location:{},
            isRegistered:false,
        
            paramFalse:false,
            paramTrue:true,

        }
    },
    computed:{
        ...mapFields([

           'states',
           'loggedInUser',
           'pleaseWait'
        

        ]),
        
        showOptInEmail(){
            if(window.SHOW_OPTIN_EMAIL==undefined){return false}
            else{return window.SHOW_OPTIN_EMAIL}
        },
        showOptInSMS(){
            if(window.SHOW_OPTIN_SMS==undefined){return false}
            else{return window.SHOW_OPTIN_SMS}
        },
        
    },
    methods:{
        isRequired(field){
            var required=false

            switch (field) {
    
                case 'Address':

                   required= window.REQUIRE_ADDRESS_EMPLOYEE
                    break;
                case 'Email':
                    required= window.REQUIRE_EMAIL
                    break;
                case 'Phone':
                    required= window.REQUIRE_PHONE_EMPLOYEE
                    
                    break;
                
                default:
                    
                    break;
            }

        
            return required
        },
        isVisible(field){
            //console.log('isvis ' + field)
            switch (field) {
                case 'OptInEmail':
                    return window.SHOW_OPTIN_EMAIL
                    break;
                case 'OptInSMS':
                    return window.SHOW_OPTIN_SMS
                    break;
                
                case 'Address':
                    return window.SHOW_ADDRESS 
                    break;
                
                default:
                    return true
                    break;
            }
        },
        setoptsms(){
            //this.sendNewSMS= this.person.optInForText
        },
        setwelcome(){
            if(this.sendNewSMS){ this.person.optInForText=true}
        },
        
       Start(){
        this.switchtabsaftersave=false
        this.message=''
        
        this.person = {
                ID:0,
                FirstName:null,
                LastName:null,
                StudentID:null,
                locationId_Primary:-1,
                personRoleId:-1,
                Birthdate:null,
                fId:null,
                InternalID:null,
                tuitionPaymentTypeID:-1,
                TuitionPaymentTypeName:null,
                sponsor:null,
                referredId:-1,
                EmailAddress:null,
                MealPlan:null,
                AddressLine1:null,
                AddressLine2:null,
                City:null,
                StateID:-1,
                ZipCode:null,
                optInForText:false,
                optInForEmail:false,
                statusID:-1,
                password:11111111,
                studentGroupId:-1,
                PhoneNumber1:null,
                PermitExpirationDate:null,
                IsActive:true,
                enrollmentDate:null

            }
            this.location={
                ID:0,
                Name:null,
                applicationMode:null,

            }
            this.$refs.mymodal.openModal()
       },
        
        checkClass(selected){
            if(selected){
                return "entryCheckLabelbold"
            }else{
                return "entryCheckLabel"
            }
        },
        cancelupdate(){
            this.$refs.mymodal.closeModal()
            this.$emit('refresh')
            
        },
        async checkNew(){
            if(this.$refs.myform.checkValidity()==false){
                this.message="Please complete all required fields before saving"
                return}
            //default to optinforemail if we aren't showing
            if(!this.showOptInEmail){
                this.person.optInForEmail=true
            }
            //if we show sms, and its checked, require phone
            if(this.showOptInSMS){
                if(this.person.optInForText && (this.person.PhoneNumber1=='' || this.person.PhoneNumber1==null)){
                    this.message="Please enter a phone number for text updates"
                    return
                } 
            }
            //if we show email, and its checked, require email
            if(this.showOptInEmail){
                if(this.person.optInForEmail && (this.person.EmailAddress=='' || this.person.EmailAddress==null)){
                    this.message="Please enter an email address for email updates"
                    return
                } 
            }
            //if we show both...one better be checked!!
            if(this.showOptInEmail && this.showOptInSMS && !this.person.optInForText && !this.person.optInForEmail){
                this.message="Please select either text or email updates"
                return
            }
  
            
           
            let req = {
                person:this.person,
                location:this.location
            
            }
            this.$store.dispatch('beforeAPI');
            var response = await this.callAPI(req,'checkperson_register')
            if(response.Successful){
             
               if(response.StringResponse !=null){
                //if success and msg, show choice to confirm
                this.savewarning=response.StringResponse
                this.$refs.confirmsavesamename.Show()
               }else{
                //if success but no msg, just go ahead and save
                this.saveNew()
               }
                
            }else{
                this.message = response.Message
            }
            this.pleaseWait=false;



        },
        async saveNew(){
            

            //verify capitalization
            this.person.FirstName = this.capitalizeWords(this.person.FirstName);
            this.person.LastName = this.capitalizeWords(this.person.LastName);
            this.person.City = this.capitalizeWords(this.person.City);
            this.location.Name=this.capitalizeWords(this.location.Name);
            
            let req = {
                person:this.person,
                location:this.location

            }

            this.$store.dispatch('beforeAPI');
            var response = await this.callAPI(req,'saveregistration')
            if(response.Successful){
                this.message="Congratulations on completing registration! Please login with your email address and we'll walk through adding your first people and trainings."
                this.isRegistered=true
                //this.$refs.mymodal.closeModal()
                this.$emit('refresh')
                
            }else{
                this.message = response.Message
            }
            this.pleaseWait=false;
        },
        capitalizeWords(str) {
            if(str==null){return null}
            return str.replace(/\b\w/g, char => char.toUpperCase());
        },
        leavePhone(){
            this.person.PhoneNumber1=this.$options.filters.formatPhone(this.person.PhoneNumber1);
        },
        
        
    }
}
</script>

<style scoped>
.entryCheckLabel{
    margin:0px 0px 0px 5px;
    font-size:medium;
    text-align: left;  
    max-width: 420px;
}
.entryCheckLabelbold{
    margin:0px 0px 0px 5px;
    font-size:medium;
    text-align: left;  
    max-width: 420px;
    font-weight:bold;
}
.updatebutton{
    height:30px;
    width:150px;
    border-radius: 5px;
    padding:3px;
    margin:0px 0px 10px 0px;
}
@media screen and (max-width: 812px) {
   
   .entry{
       flex-direction: column;
   }
}
.entry{
   width: 100%;
   display:flex;

   justify-content: space-between;
}
.entryLabel{
   margin:2px;
   font-size:medium;
   text-align: left;   
}


.entryCheckbox{
   margin-left:5px;
}
.entryCheckbox2{
    width:15px;
}
.locationdiv3{
    display:grid;
    grid-template-columns: 1fr 10fr;
    text-align:left;
}
.entryText{
   margin:5px 0px 0px 0px;
   width:95%;
   font-size:medium;
 
}
.entrySelect{
   margin:5px 2px 5px 2px;
   width:98%;
   font-size:medium;

}
.entryTextDiv{
   display:flex;
   flex-direction: row;
   min-width: 250px;
}
.entryLabelDiv{
   display:flex;
   flex-direction: row;
   min-width: 250px;
}
</style>





























